module.exports = __webpack_public_path__ + "img/chz.98d9dc02.png";